import React from 'react';
import { theme } from 'antd';

import { CustomThemeToken } from '@/theme';

const { useToken } = theme;

const CompressorWidget = ({
  width = 256,
  height = 176,
  color,
  ...rest
}: {
  width: number;
  height: number;
  color: string;
}) => {
  const { token } = useToken() as unknown as CustomThemeToken;
  const currentColor = color ?? token.colorBgContainer;

  return (
    <svg width={width} height={height} viewBox="0 0 256 176" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g filter="url(#filter0_ddd_24061_551)">
        <path
          d="M5 12C5 7.58173 8.58172 4 13 4H243C247.418 4 251 7.58172 251 12V162C251 166.418 247.418 170 243 170H13C8.58173 170 5 166.418 5 162V12Z"
          fill={currentColor}
          shapeRendering="crispEdges"
        />
        <path
          d="M5.5 12C5.5 7.85787 8.85786 4.5 13 4.5H243C247.142 4.5 250.5 7.85786 250.5 12V162C250.5 166.142 247.142 169.5 243 169.5H13C8.85787 169.5 5.5 166.142 5.5 162V12Z"
          fill={currentColor}
          shapeRendering="crispEdges"
        />
        <mask id="path-3-inside-1_24061_551" fill="white">
          <path d="M5 4H251V62H5V4Z" />
        </mask>
        <path d="M251 61H5V63H251V61Z" fill={token.colorBorderSecondary} mask="url(#path-3-inside-1_24061_551)" />
        <mask id="path-5-inside-2_24061_551" fill="white">
          <path d="M5 12C5 7.58172 8.58172 4 13 4H195V62H5V12Z" />
        </mask>
        <path
          d="M5 4H195H5ZM195 62H5H195ZM5 62V4V62ZM196 4V62H194V4H196Z"
          fill={token.colorBorderSecondary}
          mask="url(#path-5-inside-2_24061_551)"
        />
      </g>
      <path
        d="M251 97H253C254.105 97 255 97.8954 255 99V107C255 108.105 254.105 109 253 109H251V97Z"
        fill={token.colorBorder}
      />
      <defs>
        <filter
          id="filter0_ddd_24061_551"
          x="0"
          y="0"
          width="256"
          height="176"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_24061_551" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect2_dropShadow_24061_551" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_24061_551" result="effect2_dropShadow_24061_551" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0" />
          <feBlend mode="normal" in2="effect2_dropShadow_24061_551" result="effect3_dropShadow_24061_551" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_24061_551" result="shape" />
        </filter>
        <clipPath id="clip0_24061_551">
          <rect width="19.8621" height="19.8621" fill="white" transform="translate(19 25)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CompressorWidget;
